import React, { useEffect, useRef, useState } from 'react';
import DatePickerInput from '@/components/DatePickerInput';
import CloseButton from '@/ctComponents/closeButton';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import SubmitButton from '@/ctComponents/submitButton';
import clsx from 'clsx';
import CustomAsyncSelect from '@/components/CustomAsyncSelect';
import { locationOpt } from '@/actions/Helper';
import { useSelector } from 'react-redux';

export const CustomFilter = ({
  filter = {},
  setFilter,
  setSubmitFilter,
  portOptions = [],
  terminalOptions = [],
  sslOptions,
  sizeOptions,
  activeTab,
  filtersList = [], //"port","terminal","ssl","size","eta","etd","erd","cutoff","date"
}) => {
  const defaultForm = {
    port: null,
    terminal: null,
    ssl: null,
    eta: null,
    etd: null,
    erd: null,
    cutoff: null,
    size: null,
    date: null,
  };

  const selectOp = useSelector((state) => state.reducer);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [form, setFormData] = useState(defaultForm);

  const containerRef = useRef();

  const Reset = () => {
    setResetLoading(true);
    setFormData(defaultForm);
    if (setSubmitFilter) setSubmitFilter({});
    setTimeout(() => {
      setFilter({ ...filter, appliedFilters: {} });
      setFormData(defaultForm);
      setResetLoading(false);
    }, 500);
  };

  const setForm = (i, v) => setFormData({ ...form, [i]: v });

  useEffect(() => {
    if (
      Object.values(form).filter(Boolean).length > 0 &&
      filter.appliedFilters &&
      JSON.stringify(form) !== JSON.stringify(filter.appliedFilters)
    ) {
      setFormData(filter.appliedFilters);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.appliedFilters]);

  useEffect(() => {
    setFormData(defaultForm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const Filter = () => {
    setSubmitLoading(true);

    if (setSubmitFilter) setSubmitFilter({ ...form });
    setFilter({
      ...filter,
      open: false,
      appliedFilters: { ...form, vessel: filter.appliedFilters?.vessel },
    });
    setTimeout(() => {
      setSubmitLoading(false);
    }, 500);
  };

  const portOptionsList = portOptions.map((port) => ({
    value: port.slug,
    label: port.name,
  }));

  const terminalOptionsList = terminalOptions.map((terminal) => ({
    value: terminal.slug,
    label: terminal.name,
  }));

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    if (filter.open) {
      el.style.maxHeight = el.scrollHeight + 'px';
    } else {
      el.style.maxHeight = '0px';
    }
  }, [filter.open]);

  return (
    <div
      ref={containerRef}
      className="transition-all ease-in-out overflow-hidden max-h-0 duration-500">
      <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 p-4 bg-white border shadow-custom-plan border-solid  rounded border-border-tertiary ">
        {filtersList.includes('port') && (
          <CustomSelectEx
            dropdown
            minHeight={48}
            isClearable
            placeholder="Port"
            className="w-full"
            value={form.port ?? null}
            onChange={(item) => setForm('port', item)}
            options={portOptionsList}
          />
        )}
        {filtersList.includes('terminal') && (
          <CustomSelectEx
            dropdown
            minHeight={48}
            isClearable
            placeholder="Terminal"
            className={clsx('w-full')}
            value={form.terminal ?? null}
            onChange={(item) => setForm('terminal', item)}
            options={terminalOptionsList}
          />
        )}
        {filtersList.includes('ssl') && (
          <CustomSelectEx
            minHeight={48}
            dropdown
            isClearable
            placeholder="SSL"
            className={clsx('w-full')}
            value={form.ssl ?? null}
            onChange={(item) => setForm('ssl', item)}
            options={sslOptions || selectOp.ssl}
          />
        )}

        {filtersList.includes('size') && (
          <CustomSelectEx
            minHeight={48}
            dropdown
            isClearable
            placeholder="Size"
            className={clsx('w-full')}
            value={form.size ?? null}
            onChange={(item) => setForm('size', item)}
            options={sizeOptions || selectOp.size}
          />
        )}

        {filtersList.includes('loc') && (
          <CustomAsyncSelect
            dropdown
            isClearable
            height={38}
            placeholder="Enter your Location"
            value={form.loc}
            loadOptions={locationOpt}
            onChange={(item) => setForm('loc', item)}
            cacheOptions
            defaultOptions
          />
        )}

        {filtersList.includes('eta') && (
          <DatePickerInput
            placeholder="ETA"
            minHeight={48}
            format="MM/dd/yyyy"
            value={form.eta ?? null}
            onChange={(item) => setForm('eta', item)}
          />
        )}

        {filtersList.includes('etd') && (
          <DatePickerInput
            placeholder="ETD"
            minHeight={48}
            className={clsx('w-full')}
            format="MM/dd/yyyy"
            value={form.etd ?? null}
            onChange={(item) => setForm('etd', item)}
          />
        )}

        {filtersList.includes('erd') && (
          <DatePickerInput
            placeholder="ERD"
            minHeight={48}
            format="MM/dd/yyyy"
            value={form.erd ?? null}
            onChange={(item) => setForm('erd', item)}
          />
        )}

        {filtersList.includes('cutoff') && (
          <DatePickerInput
            placeholder="Cutoff"
            minHeight={48}
            format="MM/dd/yyyy"
            value={form.cutoff ?? null}
            onChange={(item) => setForm('cutoff', item)}
          />
        )}

        {filtersList.includes('date') && (
          <DatePickerInput
            placeholder="Date"
            minHeight={48}
            className={clsx('w-full')}
            format="MM/dd/yyyy"
            value={form.date ?? null}
            onChange={(item) => setForm('date', item)}
          />
        )}

        <div className="col-span-full sm:col-span-2 lg:col-start-4 lg:col-span-1 flex items-center justify-end gap-2">
          <CloseButton
            color={'#131517'}
            text={'Reset'}
            onClick={Reset}
            loading={resetLoading}
          />
          <SubmitButton text="Apply" loading={submitLoading} onClick={Filter} />
        </div>
      </div>
      <div className="h-4 w-full" />
    </div>
  );
};
